import React, { useContext, useEffect, useState } from "react";
import Head from "next/head";
import gql from "graphql-tag";
import { ThemeProvider } from "shared-components/Contexts/Theme/context";
import getConfig from "next/config"
import { FiltersContextProvider } from "shared-components/Contexts/Filters/context";
import { ConfigurationsProvider } from "shared-components/Contexts/Configurations/context";
import { AuthModalProvider } from "shared-components/Components/User/AuthModal/web";
import { UserInitialFetch } from "lib/auth";
import { GlobalComponents } from "shared-components/ViewFragments/GlobalComponents/GlobalComponents";
import { UserProvider } from "shared-components/Contexts/User/context";
import AdvertiserProvider from "src/contexts/AdvertiserContext";

import useListingTags from "src/hooks/listingTags/useListingTags";
import { Header } from "../../../RefactorSearchPage/Header/web";
import "../../../RefactorSearchPage/styles.less";
import { useGoogleTagManager } from "shared-components/GlobalHooks/web/GoogleTagManager.hook";
import { useQuery } from "@apollo/client";
import { ListingStructDataJson } from "shared-components/ViewFragments/SearchPage/ListingStructDataJson";
import { Listings } from "../../../RefactorSearchPage/Listings";
import dynamic from "next/dynamic";
import { SearchResultDisplay } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/ResultDisplay/web";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { BreadCrumbs } from "shared-components/Components/SEO/BreadCrumbs/web";
import { Footer } from "shared-components/ViewFragments/Footer/web";
import { PicHomeFooter } from "shared-components/ViewFragments/Footer/PicHomeFooter/web";
import { useRouter } from "next/router";
import { H1 } from "shared-components/Components/SEO/H1/web";
import { withApollo } from "../../../lib/apollo3";
import { withAuth } from "../../../lib/auth";
import { withContext } from "../../../lib/context";
import { withGlobalComponents } from "../../../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../../../shared-components/i18n";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { SearchResultsPagination } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/web";
import { fetchSearchResults } from "src/services/search";
import { decodeHashUrl, isProject } from "@Utils/Functions";
import { CONFIG_QUERY_FRAGMENT } from "shared-components/Contexts/Configurations/ConfigsQuery";
import { getOnlyValues } from "shared-components/Components/Filters/Filters.hook";
const { APP_THEME, ...rest } = getConfig().publicRuntimeConfig;

//@ts-ignore
const SiderBar = dynamic(
    () => import("../../../RefactorSearchPage/SiderBar"),
    { ssr: false, loading: () => <div className="search-filters"></div> }
);

const QUERY_SEARCH_RESULTS_CARDS = gql`
query landingSeo($slug: String!) {
    landingSeo(slug: $slug, perPage: 1)
    ${CONFIG_QUERY_FRAGMENT}
}
`;
const LandingPageComponent = ({fetchResult,queryLandingSeo,filters}) => {
    const router = useRouter();

    const { setListingTags } = useListingTags();
    const data = fetchResult
    const [loading, setIsLoading] = useState(queryLandingSeo.loading);
    const screen = useWindowSize();
    const [error, setError] = useState(false);
    const [sider, setSider] = useState(true);

    const breadCrumbs = {breadcrumbs: [{text: "Fincaraíz", url:"/"},{text: "Inmuebles Colombia", url: "/inmuebles-colombia"}, {text: !queryLandingSeo.loading && !queryLandingSeo.error && queryLandingSeo.data ? queryLandingSeo.data.landingSeo.seo.h1 : "", url: router.asPath}]}

    const topContent = (
        <div className="topContent-wrap">
            <div className="search-result-text-info">
                <H1 total={data?.searchFast?.paginatorInfo.total} />
                {!screen.xs && <BreadCrumbs customSeoMetaTags={breadCrumbs} />}
                {data?.searchFast?.paginatorInfo && (
                    <SearchResultDisplay
                        loading={loading || queryLandingSeo.loading}
                        error={error || queryLandingSeo.error}
                        paginatorInfo={data?.searchFast?.paginatorInfo}
                    />
                )}
            </div>
        </div>
    );


    useEffect(() => {
            setIsLoading(false);
            const dataTags = data.searchFast.data.map((property) => (
                {
                    id: property.id,
                    seaDistanceName: property.seaDistanceName,
                    isProject: isProject(property),
                    highlight: property.highlight,
                    owner: property.owner,
                    isExternal: property.isExternal,
                    tour3d: property.tour3d,
                    link: property.link,
                    legacy_propID: property.legacy_propID,
                    title: property.title,
                    tag: property.tag
                }
            ))

            setListingTags(dataTags)
    }, [data]);


    return (
        <>
            <Header showSearchBar isSticky={false} />
            <Head>
                <meta name="robots" content="index,follow" />
            </Head>

            {data?.landingSeo?.data && data?.landingSeo?.data?.length == 0 && (
                <ListingStructDataJson listings={data?.landingSeo?.data} />
            )}

            {/* {screen.lg && <TopBarFilters />} */}
            {/* {!screen.lg && affixedMobileButtons} */}

            <div className="search-page-container">
                {!sider && <SiderBar sider={sider} setSider={setSider} map={false} />}
                <div
                    className="search-results-content">
                    {topContent}
                    <Listings data={data} loading={loading || queryLandingSeo.loading} error={error || queryLandingSeo.error} forceHideBanners={true} />
                    <SearchResultsPagination
                        error={error || queryLandingSeo.error}
                        loading={loading || queryLandingSeo.loading}
                        paginatorInfo={data?.searchFast?.paginatorInfo}
                        initialUrlUpdate={false}
                        genUrlType={"query.pagina"}
                        explicitFilters={filters}
                    />
                </div>
            </div>
            <Footer />
            <PicHomeFooter />

        </>
    );
};

const LandingPage = (props) => {
    return (
        <ThemeProvider active={true} APP_THEME={APP_THEME}>
            <ConfigurationsProvider active={true} initialState={props?.ConfigContextInitialState}>
                <FiltersContextProvider
                    active={true}
                    initialState={props?.FiltersContextInitialState}>
                    <AdvertiserProvider>
                        <UserProvider active={true} initialState={null}>
                            <GlobalComponents>
                                <AuthModalProvider />
                                <UserInitialFetch />
                                <LandingPageComponent fetchResult={props.fetchResult} queryLandingSeo={props.queryLandingSeo} filters={props.filters} />
                            </GlobalComponents>
                        </UserProvider>
                    </AdvertiserProvider>
                </FiltersContextProvider>
            </ConfigurationsProvider>
        </ThemeProvider>
    );
};

LandingPage.getInitialProps = async function ({ req, query, res, asPath, apolloClient, ...rest }) {
    const queryLandingSeo = await apolloClient.query({
        query: QUERY_SEARCH_RESULTS_CARDS,
        variables: {
            slug: query?.slug
        },
    });
    const getQueryParams = (params, url) => {

        let href = url;
        //this expression is to get the query strings
        let reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i');
        let queryString = reg.exec(href);
        return queryString ? queryString[1] : null;
    };
    const filters = queryLandingSeo.loading || queryLandingSeo.error ? {} : {
        ...queryLandingSeo.data.landingSeo.filters,
        page: getQueryParams("pagina", asPath) ? parseInt(getQueryParams("pagina", asPath)) : 1
    }

    function addValues(element) {
    
        if(Array.isArray(element)) {
            const r = []
            for (let e of element) {
                r.push(addValues(e))
            }
            return r;
        }
        return {
            value: element,
            text:''
        }
    }
    
    function objectMap(obj, fn) {
        const newObject = {};
        Object.keys(obj).forEach((key) => {
          newObject[key] = fn(obj[key]);
        });
        return newObject;
      }
    
    const filtersWithValues = objectMap(filters,addValues)
    delete filtersWithValues.page

    const payload = {
		rows: 21,
		params: getOnlyValues(filtersWithValues),
		page: filters?.page || 1,
		source: 10,
	};
	const fetchResult = await fetchSearchResults(payload);

    return {
        params: {},
        FiltersContextInitialState: filtersWithValues,
        ConfigContextInitialState: queryLandingSeo.data.configuration,
        filters: filters,
		fetchResult: fetchResult,
        queryLandingSeo: queryLandingSeo,
    };
};


export default withApollo(
    withContext(withTranslation(withAuth(withGlobalComponents(LandingPage))), {
        withDummyContext: false,
        withFiltersContext: false,
        withConfigContext: true,
        withThemeContext: true,
    })
);

